import "core-js/modules/es.array.map.js";
import React from 'react';
import { withTheme } from 'styled-components';
import { AppLink } from '@finect/tabular-core/AppLink';
import { ParagraphSmall } from '@finect/tabular-core/Paragraph';
import { getQuestionPath } from '../utils';
import { Inner } from './partials';
export var QuestionRelatedList = function QuestionRelatedList(_ref) {
  var questions = _ref.questions,
    theme = _ref.theme;
  if (questions.length) {
    return React.createElement(Inner, null, React.createElement("ul", null, questions.map(function (question, index) {
      var _getQuestionPath = getQuestionPath(theme, question),
        url = _getQuestionPath.url;
      return React.createElement("li", {
        key: index
      }, React.createElement(AppLink, {
        "data-fi-event": "question-related",
        title: "Ver respuestas a la pregunta".concat(question.title),
        href: url
      }, question.title));
    })));
  }
  return React.createElement(Inner, null, React.createElement(ParagraphSmall, null, "No existen preguntas"));
};
export default React.memo(withTheme(QuestionRelatedList));